// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe {
    pointer-events: none;
}

.markupTable td,
.markupTable th {
  border: 1px solid #000;
  padding: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":["iframe {\n    pointer-events: none;\n}\n\n.markupTable td,\n.markupTable th {\n  border: 1px solid #000;\n  padding: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
